(() => {
  const root = document.documentElement;
  const sessionKey = 'my_moda_header_session';
  const observed = new WeakSet();
  let accountTimer;
  let signedOut = false;
  let accountHint = null;
  const identityKey='mip_customer_initial';
  let identity=null;
  function savedIdentity(){try{const x=JSON.parse(sessionStorage.getItem(identityKey)||'null');return x&&x.expires>Date.now()?x:null;}catch(_){return null;}}
  function updateIdentity(){
    const active=root.dataset.mipAccountActive==='true';
    const detail=active?(identity||savedIdentity()):null;
    document.querySelectorAll('.header__icon--account,.customer_acc').forEach(el=>{
      if(detail?.initial){el.dataset.mipInitial=detail.initial;el.title=detail.firstName?'Hi, '+detail.firstName:'My Moda';}
      else {delete el.dataset.mipInitial;el.removeAttribute('title');}
    });
  }
  window.addEventListener('mip:customer-personalisation',ev=>{
    const d=ev.detail||{};const name=String(d.firstName||'').trim().slice(0,40);
    identity=d.signedIn&&name?{firstName:name,initial:name[0].toLocaleUpperCase(),expires:Date.now()+5*60*1000}:null;
    try{if(identity)sessionStorage.setItem(identityKey,JSON.stringify(identity));else sessionStorage.removeItem(identityKey);}catch(_){}
    updateIdentity();
  });
  const creditKey='mip_verified_credit_hint';
  let creditState=null;
  function readCredit(){ try {const x=JSON.parse(sessionStorage.getItem(creditKey)||'null');return x && x.expires>Date.now()?x:null;}catch(_){return null;} }
  function updateCreditBadge(){ const verified=creditState||readCredit(); const active=root.dataset.mipAccountActive==='true' && !!verified?.hasCredit; root.dataset.mipStoreCredit=String(active); }
  window.addEventListener('mip:store-credit-status',event=>{ const verified=event.detail?.verified===true; creditState=verified?{hasCredit:event.detail.hasCredit===true,expires:Date.now()+5*60*1000}:null; try{ if(creditState)sessionStorage.setItem(creditKey,JSON.stringify(creditState));else sessionStorage.removeItem(creditKey); }catch(_){} updateCreditBadge(); });
  const loadedAt = Date.now();

  function storedSession() {
    try {
      const hint = JSON.parse(sessionStorage.getItem(sessionKey) || 'null');
      const logout = Number(localStorage.getItem('my_moda_signed_out') || 0);
      return hint && Number.isFinite(hint.expires) && hint.expires > Date.now() && hint.updatedAt > logout ? hint : null;
    } catch (_) { return null; }
  }

  function updateAccount() {
    clearTimeout(accountTimer);
    try { if (Number(localStorage.getItem('my_moda_signed_out')) > (accountHint?.updatedAt || loadedAt)) signedOut = true; } catch (_) {}
    const hint = accountHint || storedSession();
    const active = !signedOut && (root.dataset.mipCustomer === 'true' || !!(hint && hint.expires > Date.now()));
    root.dataset.mipAccountActive = String(active);
    updateCreditBadge();
    updateIdentity();
    if (!signedOut && hint && hint.expires > Date.now()) accountTimer = setTimeout(updateAccount, Math.min(hint.expires - Date.now() + 10, 2147483647));
  }

  function browserCount() {
    try {
      const items = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      return Array.isArray(items) ? new Set(items.filter(item => typeof item === 'string' && item)).size : 0;
    } catch (_) { return 0; }
  }

  function updateWishlist() {
    const counts = [...document.querySelectorAll('[data-wishlist-count]')].map(el => el.textContent.trim()).filter(text => /^\d+$/.test(text));
    root.dataset.mipWishlistActive = String(counts.length ? counts.some(text => Number(text) > 0) : browserCount() > 0);
  }

  const observer = new MutationObserver(updateWishlist);
  function connectCounts() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      if (observed.has(el)) return;
      observed.add(el);
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
    updateWishlist();
  }

  window.addEventListener('mip:account-status', event => {
    signedOut = event.detail?.signedIn !== true;
    if(signedOut){creditState=null;identity=null;try{sessionStorage.removeItem(creditKey);sessionStorage.removeItem(identityKey);}catch(_){}}
    accountHint = signedOut ? null : event.detail;
    updateAccount();
  });
  window.addEventListener('storage', event => {
    if (event.key === 'my_moda_signed_out') {
      signedOut = true;
      accountHint = null;
      creditState=null;
      identity=null;
      try { sessionStorage.removeItem(identityKey); }catch(_){}
      try { sessionStorage.removeItem(creditKey); }catch(_){}
      try { sessionStorage.removeItem(sessionKey); } catch (_) {}
      updateAccount();
    }
    if (event.key === 'wishlistItem' || event.key === null) {
      document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(browserCount()); });
      updateWishlist();
    }
  });
  window.addEventListener('pageshow', () => { accountHint = null; updateAccount(); connectCounts(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateAccount(); });
  document.addEventListener('shopify:section:load', () => {connectCounts();updateIdentity();});
  updateAccount();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectCounts, { once: true });
  else connectCounts();
})();
